export enum GridPeriodFilter {
    Month = 'month',
    Week = 'week',
    Day = 'day'
}

export const gridPeriodFilterDictionary = {
    [GridPeriodFilter.Month]: 30,
    [GridPeriodFilter.Week]: 7,
    [GridPeriodFilter.Day]: 1
};
